export enum JiraTicketType {
  Investigation = "Investigation",
  Bug = "Bug",
  Task = "Task",
  BuildFailure = "Build Failure",
  Epic = "Epic",
  Incident = "Incident",
}
